import type { ComponentProps } from 'react';
import React from 'react';
import type { Flex } from '@skin-seoul/design-system';
import { HorizontalProductCardSkeleton, VerticalProductCardSkeleton } from '@skin-seoul/shared-components';
type ProductCardSkeletonProps = {
  orientation: 'vertical' | 'horizontal';
} & ComponentProps<typeof Flex>;
const ProductCardSkeleton = ({
  orientation,
  ...props
}: ProductCardSkeletonProps) => {
  if (orientation === 'horizontal') {
    return <HorizontalProductCardSkeleton {...props} />;
  }
  return <VerticalProductCardSkeleton {...props} data-sentry-element="VerticalProductCardSkeleton" data-sentry-component="ProductCardSkeleton" data-sentry-source-file="ProductCard.Skeleton.tsx" />;
};
export default ProductCardSkeleton;